var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.875C24.4873 11.875 28.125 15.5127 28.125 20C28.125 24.4873 24.4873 28.125 20 28.125C15.5127 28.125 11.875 24.4873 11.875 20C11.875 15.5127 15.5127 11.875 20 11.875ZM18.8926 16.5859C18.2679 16.2392 17.5002 16.6917 17.5 17.4062V22.5938C17.5001 23.3084 18.2678 23.7601 18.8926 23.4131L23.5615 20.8193C24.2043 20.4621 24.2044 19.5369 23.5615 19.1797L18.8926 16.5859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNew);
export default __webpack_public_path__ + "static/media/play-new.1c920349a83c12f99e0c67340e35421d.svg";
export { ForwardRef as ReactComponent };